import type { Group } from '@mend/types/group';
import type { Org } from '@mend/types/org';
import type { User } from '@mend/types/user';
import type { Response } from '#types/common.ts';

import { api } from '../http-clients.ts';

export type GetMeResponsePayload = {
  user: User;
  org: Org;
};

export async function getMe(): Promise<GetMeResponsePayload> {
  return api
    .get<Response<GetMeResponsePayload>>('/user/me')
    .then((response) => response.data.payload);
}

export type GetUsersParams = {
  id?: number | number[];
  role?: User['role'][];
  excludeUsers?: number[];
  search?: string;
  page?: number;
  limit?: number;
  order?: string;
  includeGroups?: 0 | 1;
  includeTemporary?: 0 | 1;
};

export type GetUsersResponse = {
  groups?: Group[];
  users: User[];
  isPageable?: boolean;
  limit?: number | null;
  page?: number | null;
  totalItems?: number;
  totalPages?: number;
};

export function getUsers(params?: GetUsersParams, signal?: AbortSignal): Promise<GetUsersResponse> {
  return api
    .get<Response<GetUsersResponse>>('/user', {
      params,
      signal,
    })
    .then((res) => res.data.payload);
}
